import { Link } from "react-router-dom";
import { ArrowLeft, Download } from "lucide-react";
import { jsPDF } from "jspdf";
import HammLogo from "@/components/landing/HammLogo";

const H = ({ children }) => (
  <h2 className="mt-12 mb-4 text-xl font-bold tracking-tight text-[var(--ci-grey)]">{children}</h2>
);
const P = ({ children }) => <p className="text-sm sm:text-base leading-relaxed text-[var(--ci-grey)]">{children}</p>;

function LegalLayout({ title, children, testid }) {
  return (
    <div className="min-h-screen bg-white text-[var(--ci-grey)]" data-testid={testid}>
      <header className="border-b border-[#E3E8EC] bg-white/90 backdrop-blur-md sticky top-0 z-40">
        <div className="max-w-[900px] mx-auto px-6 h-[76px] flex items-center justify-between">
          <Link to="/" aria-label="Zur Startseite" className="flex items-center" data-testid="legal-logo-link">
            <HammLogo className="h-10 w-auto block" />
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="flex items-center gap-2 px-5 h-10 rounded-full border border-[#E3E8EC] text-[var(--ci-grey)] hover:text-[var(--ci-turquoise)] hover:border-[var(--ci-turquoise)] transition-colors duration-200 font-tech text-[11px] tracking-[0.18em] uppercase"
          >
            <ArrowLeft size={13} /> Zurück
          </Link>
        </div>
      </header>
      <main className="max-w-[900px] mx-auto px-6 py-16 lg:py-20">
        <h1 className="text-3xl lg:text-4xl font-bold tracking-tight text-[var(--ci-grey)]" data-testid={`${testid}-title`}>{title}</h1>
        <div className="mt-8">{children}</div>
      </main>
      <footer className="border-t border-[#E3E8EC]">
        <div className="max-w-[900px] mx-auto px-6 py-8 flex flex-wrap gap-x-8 gap-y-2 font-tech text-[10px] tracking-[0.2em] uppercase text-[var(--ci-grey)]">
          <span>© 2026 Hamm Entwicklung + Produktion GmbH</span>
          <Link to="/impressum" className="hover:text-[var(--ci-turquoise)] transition-colors" data-testid="legal-footer-impressum">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-[var(--ci-turquoise)] transition-colors" data-testid="legal-footer-datenschutz">Datenschutz</Link>
          <Link to="/agb" className="hover:text-[var(--ci-turquoise)] transition-colors" data-testid="legal-footer-agb">AGB</Link>
        </div>
      </footer>
    </div>
  );
}

export function ImpressumPage() {
  return (
    <LegalLayout title="Impressum" testid="impressum-page">
      <H>Angaben gemäß § 5 DDG</H>
      <P>
        Hamm Entwicklung + Produktion GmbH<br />
        Max-Planck-Str. 13<br />
        47608 Geldern<br />
        Deutschland
      </P>
      <H>Vertreten durch</H>
      <P>Geschäftsführung: Jakob Hamm, Arthur Hamm</P>
      <H>Kontakt</H>
      <P>
        Telefon: <a href="tel:+4928319901500" className="text-[var(--ci-blue)] hover:text-[var(--ci-turquoise)] transition-colors">02831 9901-500</a><br />
        E-Mail: <a href="mailto:verkauf@hamm.gmbh" className="text-[var(--ci-blue)] hover:text-[var(--ci-turquoise)] transition-colors">verkauf@hamm.gmbh</a>
      </P>
      <H>Registereintrag</H>
      <P>
        Eintragung im Handelsregister<br />
        Registergericht: Amtsgericht Kleve<br />
        Registernummer: HRB 12056
      </P>
      <H>Umsatzsteuer-ID</H>
      <P>
        Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE 287 921 642
      </P>
      <H>Steuernummer</H>
      <P>
        Finanzamt Geldern, Steuer-Nr.: 113/5701/2572
      </P>
      <H>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</H>
      <P>
        Arthur Hamm, Anschrift wie oben
      </P>
      <H>Haftung für Inhalte</H>
      <P>
        Die Inhalte dieser Seite wurden mit großer Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und
        Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir für eigene
        Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
      </P>
      <H>Haftung für Links</H>
      <P>
        Unser Angebot enthält gegebenenfalls Links zu externen Websites Dritter, auf deren Inhalte wir keinen
        Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
        Seiten verantwortlich. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist ohne konkrete
        Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden
        derartige Links umgehend entfernt.
      </P>
      <H>Urheber- und Markenrechte</H>
      <P>
        Die durch die Hamm Entwicklung + Produktion GmbH erstellten Inhalte, Grafiken, das Firmenlogo, die
        Wort-/Bildmarke „Hamm EP" sowie sämtliche technischen Zeichnungen und CAD-Darstellungen auf dieser
        Website unterliegen dem deutschen Urheber- und Markenrecht. Die Vervielfältigung, Bearbeitung,
        Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der
        schriftlichen Zustimmung der Hamm Entwicklung + Produktion GmbH. Genannte Marken, Normen (z. B.
        EN&nbsp;15085, ISO&nbsp;9001, DIN&nbsp;6701, IRIS/ISO&nbsp;22163) und Bezeichnungen Dritter dienen
        ausschließlich der beschreibenden Bezugnahme auf die entsprechenden Regelwerke und bleiben Eigentum
        ihrer jeweiligen Inhaber. Ein rechtsgeschäftlicher Bezug zu diesen Institutionen wird hierdurch nicht
        begründet.
      </P>
      <H>Bildnachweise</H>
      <P>
        Firmenlogo, Produktbilder, Werkhallen- und Maschinenaufnahmen: © Hamm Entwicklung + Produktion GmbH.
        Verwendete lizenzfreie Stock-Videos für den Hero-Bereich stammen von Pexels (Pexels-Lizenz, Nutzung
        auch für kommerzielle Zwecke frei, keine Attributionspflicht).
      </P>
      <H>Verbraucherstreitbeilegung / Universalschlichtungsstelle</H>
      <P>
        Die Hamm Entwicklung + Produktion GmbH ist ausschließlich im Geschäftsverkehr zwischen Unternehmen
        (B2B) tätig. Sie ist nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle im Sinne des § 36 VSBG teilzunehmen. Die EU-Kommission stellt eine
        Plattform zur Online-Streitbeilegung (OS-Plattform) unter{" "}
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[var(--ci-blue)] hover:text-[var(--ci-turquoise)] transition-colors">ec.europa.eu/consumers/odr</a>{" "}
        bereit. Diese richtet sich an Verbraucher und ist für den B2B-Verkehr nicht einschlägig.
      </P>
    </LegalLayout>
  );
}

export function DatenschutzPage() {
  return (
    <LegalLayout title="Datenschutzerklärung" testid="datenschutz-page">
      <H>1. Verantwortlicher</H>
      <P>
        Hamm Entwicklung + Produktion GmbH, Max-Planck-Str. 13, 47608 Geldern, Deutschland,
        E-Mail: verkauf@hamm.gmbh, Telefon: 02831 9901-500, vertreten durch die Geschäftsführung Jakob Hamm und Arthur Hamm
      </P>
      <H>2. Verarbeitung bei Fertigungsanfragen</H>
      <P>
        Wenn Sie uns über das Anfrage-Portal kontaktieren, verarbeiten wir die von Ihnen angegebenen Daten
        (Firma, Ansprechpartner, E-Mail-Adresse, Telefonnummer, Angaben zur Bearbeitung sowie optional
        hochgeladene Dateien wie CAD-Daten und Zeichnungen) zur Bearbeitung Ihrer Anfrage und zur
        Angebotserstellung. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen).
      </P>
      <H>3. Speicherung und Löschung</H>
      <P>
        Ihre Anfragedaten inklusive hochgeladener Dateien werden auf unseren Systemen gespeichert und nur so
        lange aufbewahrt, wie es für die Bearbeitung Ihrer Anfrage und gesetzliche Aufbewahrungspflichten
        erforderlich ist. Anschließend werden die Daten gelöscht.
      </P>
      <H>4. Empfänger und Dienstleister</H>
      <P>
        Zum Betrieb dieser Website setzen wir Dienstleister für Hosting, Dateiablage und E-Mail-Versand ein.
        Mit diesen bestehen Verträge zur Auftragsverarbeitung gemäß Art. 28 DSGVO. Eine Weitergabe Ihrer Daten
        an sonstige Dritte erfolgt nicht.
      </P>
      <H>5. Reichweitenanalyse (PostHog)</H>
      <P>
        Diese Website nutzt PostHog zur pseudonymen Analyse des Nutzungsverhaltens (Seitenaufrufe,
        Interaktionen, technische Kennzahlen). Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
        Interesse an der Optimierung des Angebots). Personenprofile werden erst erstellt, wenn Sie sich am
        Admin-Bereich anmelden („person_profiles: identified_only"). IP-Adressen werden gekürzt bzw. anonymisiert
        verarbeitet. Anbieter ist PostHog Inc., 965 Mission St, San Francisco, CA 94103, USA, mit EU-Hosting
        über den Endpunkt ap.emergent.sh.
      </P>
      <H>6. Cookies</H>
      <P>
        Diese Website verwendet keine Tracking- oder Marketing-Cookies. Im passwortgeschützten Admin-Bereich
        wird ein technisch notwendiges Sitzungs-Cookie (HttpOnly) zur Anmeldung verwendet
        (Art. 6 Abs. 1 lit. f DSGVO).
      </P>
      <H>7. Ihre Rechte</H>
      <P>
        Sie haben das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16 DSGVO), Löschung
        (Art. 17 DSGVO), Einschränkung der Verarbeitung (Art. 18 DSGVO), Datenübertragbarkeit
        (Art. 20 DSGVO) sowie Widerspruch gegen die Verarbeitung (Art. 21 DSGVO). Zudem besteht ein
        Beschwerderecht bei der zuständigen Aufsichtsbehörde.
      </P>
      <H>8. Datensicherheit</H>
      <P>
        Diese Website nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung. Damit sind Inhalte,
        die Sie an uns übermitteln, für Dritte nicht mitlesbar.
      </P>
    </LegalLayout>
  );
}

// AGB-Struktur: dient sowohl der Website-Anzeige als auch dem PDF-Export
const AGB_SECTIONS = [
  {
    heading: "§ 1 Geltungsbereich und B2B-Fokus",
    paragraphs: [
      "(1) Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB\") gelten ausschließlich für alle Verträge zur Lieferung von Waren und Lohnfertigungen, die ein Kunde mit der Hamm Entwicklung + Produktion GmbH (nachfolgend „Verkäufer\") abschließt.",
      "(2) Unsere AGB gelten nur gegenüber Unternehmern, juristischen Personen des öffentlichen Rechts oder öffentlich-rechtlichen Sondervermögen. Verträge mit Verbrauchern werden ausdrücklich nicht geschlossen.",
      "(3) Hiermit wird der Einbeziehung von eigenen Bedingungen des Kunden widersprochen, es sei denn, es ist schriftlich etwas anderes vereinbart.",
    ],
  },
  {
    heading: "§ 2 Angebot, Vertragsschluss und Geistiges Eigentum",
    paragraphs: [
      "(1) Die in Katalogen oder auf der Website enthaltenen Beschreibungen stellen keine verbindlichen Angebote dar. Der Vertrag kommt erst durch unsere schriftliche Auftragsbestätigung oder Warenauslieferung zustande.",
      "(2) Alle Angaben wie Maße, Gewichte oder Abbildungen sind bestmöglich ermittelt, jedoch nur annähernd maßgeblich.",
      "(3) An Konstruktionszeichnungen, Modellen, CAD-Daten und sonstigen technischen Unterlagen behalten wir uns Eigentums- und Urheberrechte strikt vor.",
    ],
  },
  {
    heading: "§ 3 Preise, Lieferung und Annahmeverzug",
    paragraphs: [
      "(1) Der Kunde trägt grundsätzlich alle anfallenden Versand- und Frachtkosten. Die reguläre Lieferzeit beträgt 6 bis 8 Wochen ab finaler Auftragsbestätigung.",
      "(2) Handelt der Kunde als Unternehmer, geht die Gefahr des zufälligen Untergangs auf den Kunden über, sobald der Verkäufer die Sache der Transportperson übergeben hat.",
      "(3) Wird die Auslieferung versandbereiter Ware auf Wunsch des Kunden verzögert, sind wir berechtigt, pro angefangenem Monat Lagergeld in Höhe von 0,5 %, maximal jedoch 5 % des Netto-Rechnungsbetrages zu berechnen.",
    ],
  },
  {
    heading: "§ 4 Verlängerter Eigentumsvorbehalt",
    paragraphs: [
      "(1) Wir behalten uns das Eigentum an der gelieferten Ware bis zur vollständigen Bezahlung aller Forderungen vor.",
      "(2) Eine etwaige Verarbeitung, Vermischung oder Montage der gelieferten Vorbehaltsware nimmt der Käufer für uns vor. Wird die Ware mit anderen Gegenständen verbunden oder in Module integriert, erwerben wir Miteigentum an der neuen Sache im Verhältnis des Rechnungswertes unserer Ware zur Hauptsache.",
    ],
  },
  {
    heading: "§ 5 Mängelhaftung und Garantie",
    paragraphs: [
      "(1) Die Gewährleistungsfrist beträgt 12 Monate ab Lieferdatum. Ausgenommen hiervon sind Verschleißteile wie Batterien, Schläuche und Pumpen; hierfür gilt eine verkürzte Frist von 6 Monaten.",
      "(2) Der Kunde ist zur kaufmännischen Untersuchung und Rüge nach § 377 HGB verpflichtet.",
      "(3) Im Garantiefall wählen wir zwischen Reparatur oder Austausch. Wir sind berechtigt, dem Kunden Ersatzteile zur zumutbaren Eigenmontage zuzusenden. Ein Anspruch auf Vor-Ort-Reparatur besteht nicht.",
      "(4) Die Verjährungsfrist beginnt durch eine Ersatzlieferung nicht erneut.",
    ],
  },
  {
    heading: "§ 6 Freiwillige Rücknahme von Standardartikeln",
    paragraphs: [
      "Eine freiwillige Rücknahme von intakten, originalverpackten Standardprodukten (wie Hygienespendern) ist ausgeschlossen, es sei denn, wir stimmen dieser im Einzelfall vorab schriftlich zu. In diesem Fall erfolgt die Rücknahme gegen einen pauschalen Einbehalt von 35 % des Nettowarenwertes zur Deckung der Prüf- und Wiedereinlagerungskosten. Kundenspezifische Lohnfertigungen sind von jeglicher Rückgabe ausgeschlossen.",
    ],
  },
  {
    heading: "§ 7 Haftungsbeschränkung",
    paragraphs: [
      "Wir schließen unsere Haftung für leicht fahrlässige Pflichtverletzungen aus, sofern diese keine vertragswesentlichen Pflichten, Schäden an Leben, Körper oder Gesundheit betreffen. Die Haftung für mittelbare Schäden, entgangenen Gewinn oder Produktionsausfälle ist ausgeschlossen.",
    ],
  },
  {
    heading: "§ 8 Besondere Bedingungen für Lohnfertigung nach Kundenvorgaben",
    paragraphs: [
      "Liefert der Kunde Vorgaben (z. B. CAD-Daten), trägt er die alleinige Verantwortung dafür, dass durch die Fertigung keine Schutzrechte Dritter verletzt werden. Er stellt uns vollumfänglich von Ansprüchen Dritter frei.",
    ],
  },
  {
    heading: "§ 9 Anwendbares Recht und Gerichtsstand",
    paragraphs: [
      "Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. Ausschließlicher Erfüllungsort und Gerichtsstand für alle Streitigkeiten ist der Geschäftssitz des Verkäufers in Geldern.",
    ],
  },
];

function downloadAGBasPDF() {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  const marginX = 20;
  const contentW = pageW - marginX * 2;
  let y = 25;

  // Kopf
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.setTextColor(0x2c, 0x57, 0xd2);
  doc.text("Allgemeine Geschäftsbedingungen (AGB)", marginX, y);
  y += 7;
  doc.setFontSize(11);
  doc.setTextColor(0x70, 0x70, 0x6f);
  doc.text("Hamm Entwicklung + Produktion GmbH", marginX, y);
  y += 4;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("Max-Planck-Str. 13 · 47608 Geldern · Deutschland", marginX, y);
  y += 10;

  const ensureSpace = (needed) => {
    if (y + needed > pageH - 20) {
      doc.addPage();
      y = 25;
    }
  };

  AGB_SECTIONS.forEach((section) => {
    ensureSpace(14);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(0x2c, 0x57, 0xd2);
    doc.text(section.heading, marginX, y);
    y += 6;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(0x33, 0x33, 0x33);
    section.paragraphs.forEach((p) => {
      const lines = doc.splitTextToSize(p, contentW);
      lines.forEach((line) => {
        ensureSpace(5);
        doc.text(line, marginX, y);
        y += 4.6;
      });
      y += 2;
    });
    y += 4;
  });

  // Fuß auf jeder Seite
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(0x99, 0x99, 0x99);
    doc.text(
      `© 2026 Hamm Entwicklung + Produktion GmbH · Seite ${i} von ${totalPages}`,
      pageW / 2,
      pageH - 10,
      { align: "center" }
    );
  }

  doc.save("AGB_Hamm_GmbH.pdf");
}

export function AGBPage() {
  return (
    <LegalLayout title="Allgemeine Geschäftsbedingungen (AGB)" testid="agb-page">
      <button
        type="button"
        onClick={downloadAGBasPDF}
        data-testid="agb-download-btn"
        className="mt-4 mb-2 inline-flex items-center gap-3 px-7 h-12 rounded-full bg-[var(--ci-blue)] hover:bg-[var(--ci-turquoise)] text-white font-tech text-[11px] tracking-[0.2em] uppercase transition-colors duration-200 active:scale-[0.98] shadow-[0_10px_30px_rgba(44,87,210,0.30)]"
      >
        <Download size={15} /> AGB als PDF herunterladen
      </button>

      <p className="mt-6 text-sm text-[var(--ci-grey)]">
        Nachfolgend finden Sie die vollständigen Allgemeinen Geschäftsbedingungen der Hamm Entwicklung + Produktion GmbH.
      </p>

      {AGB_SECTIONS.map((section) => (
        <div key={section.heading} data-testid={`agb-section-${section.heading.split(" ")[1].replace(/\W/g, "")}`}>
          <H>{section.heading}</H>
          {section.paragraphs.map((p, i) => (
            <p key={i} className="text-sm sm:text-base leading-relaxed text-[var(--ci-grey)] mt-3">
              {p}
            </p>
          ))}
        </div>
      ))}
    </LegalLayout>
  );
}
